import { faLock } from "@fortawesome/free-solid-svg-icons";
import { faCircle } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext } from "react";
import BadgeCircle from "../../common/badge/BadgeCircle";
import { Column, Row } from "../../common/columns";
import DashboardItem from "../../common/dashboard/DashboardItem";
import { UserContext } from "../../common/user/UserContext";
import { ThemeContext } from "../../common/theme/ThemeContext";
import { useTranslation } from "react-i18next";
import Icon from "@mdi/react";
import { mdiVote } from "@mdi/js";

function DashboardPage() {
  const user = useContext(UserContext);
  const { t } = useTranslation();
  const theme = useContext(ThemeContext);
  return (
    <div className="container">
      <Row>
        <Column>
          <DashboardItem
            link="/receivedRequests"
            label={t("requests.received.title")}
            labelSize="3"
          >
            <BadgeCircle
              value={user.receivedRequests}
              icon={faCircle}
              size={user.receivedRequests.length}
              iconSize="5"
              className="mt-2"
            />
          </DashboardItem>
        </Column>
        <Column>
          <DashboardItem
            link="/requirementsInResolving"
            label={t("requests.inResolving")}
            labelSize="3"
          >
            <BadgeCircle
              value={user.inResolvingRequests}
              icon={faCircle}
              iconColor={theme.iconColor}
              size={user.inResolvingRequests.length}
              iconSize="5"
              className="mt-2"
            />
          </DashboardItem>
        </Column>
        <Column>
          <DashboardItem link="/resolvedRequests" label={t("requests.resolved")} labelSize="3">
            <BadgeCircle
              value={user.resolvedRequests}
              icon={faCircle}
              iconColor={theme.iconColor}
              size={user.resolvedRequests.length}
              iconSize="5"
              className="mt-2"
            />
          </DashboardItem>
        </Column>
      </Row>
      <Row>
        <Column size="4">
          <DashboardItem link="/allRequests" label={t("requests.all")} labelSize="3">
            <BadgeCircle
              value={user.allRequests}
              icon={faCircle}
              iconColor={theme.iconColor}
              size={user.receivedRequests.length}
              iconSize="5"
              className="mt-2"
            />
          </DashboardItem>
        </Column>
        <Column size="4">
          <DashboardItem link="/archive" label={t("requests.archive")} labelSize="3">
            <FontAwesomeIcon
              size="3x"
              className={`has-text-${theme.iconColor} mt-4`}
              icon={faLock}
            />
          </DashboardItem>
        </Column>
        <Column className="is-4">
          <DashboardItem link="/elections" label={t("requests.voting.voting")} labelSize="3">
            <Icon
              path={mdiVote}
              size={3} // not in use, check scss class "dashboard-vote-icon" - iz portala, upitno dal je potrebno tu
              className={`dashboard-vote-icon has-text-${theme.iconColor} mt-2`}
            />
          </DashboardItem>
        </Column>
      </Row>
    </div>
  );
}

export default DashboardPage;
